<template>
  <div>
    <AppPage class="message-page">
      <!-- <FixedHeader /> -->
      <!-- 搜索和标签区域 -->
      <div class="header-content flex justify-between items-center">
        <!-- <div class="search-box flex items-center " @click.stop.prevent="handleSearch"
          @touchend.stop.prevent="handleSearch">
          <img src="@/assets/images/home/search.webp" class="w-10px h-10px mr-5px" />
          <div class="search-input">
            {{ t('home.search') }}
          </div>
        </div> -->
        <div class="tabs-box ">
          <div class="tab-item font-700" :class="{ active: activeTab === tab.type }" v-for="tab in tabs" :key="tab.type"
            @click="handleTabClick(tab.type)">
            {{ tab.name }}
          </div>
        </div>
        <div class="w-24px h-24px flex items-center justify-center" @click="handleSearch">
          <img src="@/assets/images/home/search_icon.webp" class="w-full h-full" />
        </div>
      </div>

      <!-- 消息列表区域 -->
      <div class="message-list-container" ref="messageListContainerRef" @scroll="onContainerScroll">
        <!-- 🔧 错误状态显示（网络错误） -->
        <div v-if="error && !loading" class="flex flex-col items-center justify-center mt-150px">
          <div class="color-#fff text-12px">{{ t('errors.networkError') }}</div>
          <div @click="handleRetry()" class="retry-btn">{{ t('errors.retry') }}</div>
        </div>

        <!-- 🔧 骨架屏加载状态（只在初始加载或重试时显示，下拉刷新时不显示） -->
        <div v-else-if="currentState.loading && messageList.length === 0" class="message-list-skeleton">
          <div v-for="i in 7" :key="i" class="skeleton-item">
            <div class="skeleton-avatar"></div>
            <div class="skeleton-content">
              <div class="skeleton-line skeleton-line-title"></div>
              <div class="skeleton-line skeleton-line-text"></div>
            </div>
          </div>
        </div>
        <div v-else-if="messageList.length === 0" class="message-list-empty flex-center">
          <AppEmpty :imgSrc="activeTab === 2 ? allEmpty : messageEmpty" :showBtn="true" />
        </div>

        <!-- 🔧 正常内容显示 -->
        <van-pull-refresh v-else v-model="loading" @refresh="onRefresh" :loosing-text="('releaseToRefresh')"
          class="h-100%" loading-text="Loading" pulling-text="Pulling" success-duration="1000" :disabled="!isAtTop">
          <template #loading>
            <div class="loading-content">
              <div class="loading-spinner">
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
              </div>
            </div>
          </template>
          <template #loosing>
            <div class="loading-content">
              <div class="loading-spinner">
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
              </div>
            </div>
          </template>
          <div class="message-list" v-if="messageList.length > 0" ref="containerRef">
            <!-- 🔧 使用虚拟列表优化性能 -->
            <AppVirtualList :items="messageList" :item-height="70" :buffer="5" key-field="id"
              :style="{ height: virtualListHeight }" @scroll="handleVirtualListScroll">
              <template #item="{ item }">
                <div :ref="(el) => setItemRef(item.id, el)" :data-item-id="item.id" class="message-item-wrapper"
                  @click="handleItemClick(item)">
                  <van-swipe-cell :ref="(el) => setSwipeRef(item.id, el)" @open="handleSwipeOpen(item.id)"
                    @close="handleSwipeClose(item.id)">
                    <van-cell :border="false">
                      <div class="message-item flex ">
                        <div class="flex">
                          <!-- 预加载背景图片 -->
                          <img :src="item.roleInfo.background"
                            class="w-56px h-56px overflow-hidden rounded-full hidden">
                          <!-- 头像图片 -->
                          <van-image :src="item.avatar" class="w-56px h-56px overflow-hidden rounded-full" fit="cover">
                            <template v-slot:loading>
                              <div class="w-56px h-56px">
                                <img src="@/assets/images/message/defaultAvatar.webp" alt="" class="w-full h-full" />
                              </div>
                            </template>
                          </van-image>
                          <div class="ml-10px color-white font-900 text-14px h-full ">
                            <div class="flex justify-between items-center mt-3px">
                              <div class="w-120px text-ellipsis text-left h-50% lh-100% font-500 ">
                                {{ item.name }}
                              </div>
                              <div class="flex items-center justify-end gap-8px flex-1">
                                <div class="text-9px text-right font-500 message-content-time">
                                  {{ formatTime(item.createdAt) }}
                                </div>
                                <!-- 🔧 未读消息数量
                                <div v-if="getUnreadCount(item) > 0" class="unread-badge">
                                  {{ formatUnreadCount(getUnreadCount(item)) }}
                                </div> -->
                              </div>
                            </div>

                            <div
                              class="w-270px text-ellipsis mt-10px h-50% lh-100% text-left text-12px font-500 message-content"
                              v-html="removeThinkingWithRegex(item.content)">
                            </div>
                          </div>
                        </div>
                      </div>
                    </van-cell>
                    <template #right>
                      <div class="delete-btn" @click="handleDelete(item.id)">
                        <img src="@/assets/images/message/delete.webp" />
                      </div>
                    </template>
                  </van-swipe-cell>
                </div>
              </template>
              <template #footer>
                <div v-if="loadingMore" class=" flex items-center justify-center py-10px">
                  <div class="loading-content">
                    <div class="loading-spinner">
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                      <div class="spinner-ring"></div>
                    </div>
                  </div>
                </div>
                <div v-else-if="!hasMore && messageList.length > 0"
                  class="no-more-indicator flex items-center justify-center py-10px">
                  <span class="color-#fff66 text-12px opacity-50">No more messages</span>
                </div>
              </template>
            </AppVirtualList>
          </div>
        </van-pull-refresh>
      </div>
      <!-- 底部占位 -->
      <AppOccupySpace height="100px"></AppOccupySpace>
    </AppPage>
  </div>

</template>

<script setup lang="ts" name="messagePage">
import { FixedHeader, AppPage, AppOccupySpace } from '@/components/layout'
import { AppEmpty, AppVirtualList } from '@/components/display'
import { MessageAPI } from '@/services/message'
import { showToast, showLoadingToast, closeToast } from '@/utils/toast'
import { useI18n } from 'vue-i18n'
import { ref, onMounted, computed, nextTick, onUnmounted, watch } from 'vue'
import theme from '@/styles/theme'
import { useRouter, useRoute } from 'vue-router'
import messageEmpty from '@/assets/images/message/like_empy.webp';
import allEmpty from '@/assets/images/message/empty.webp';

import { useDialog } from '@/composables/useDialog'
import { useMessageStore } from '@/stores/message'
import { useChatStore } from '@/stores/chat'
const router = useRouter()
const route = useRoute()
const messageStore = useMessageStore()
const chatStore = useChatStore()
const activeTab = computed(() => messageStore.activeTab)
const messageList = computed(() => messageStore.getCurrentState().items)
const currentState = computed(() => messageStore.getCurrentState())
const error = computed(() => currentState.value.error)
const loadingMore = computed(() => currentState.value.loadingMore)
const hasMore = computed(() => currentState.value.hasMore)
const { t } = useI18n()
const dialog = useDialog()

/**
 * 🔧 获取数字人的未读消息数量
 * 注意：消息列表中的 roleId 对应 chatStore 中的数字人 ID
 */
const getUnreadCount = (item: any) => {
  // 🔧 优先使用 roleId（消息列表中的角色ID），确保转换为字符串类型以匹配 chatStore 中的数字人 ID
  // chatStore 中的数字人 ID 是字符串类型，所以需要统一转换
  const roleId = item.roleId
  if (!roleId) {
    return 0
  }
  // 确保转换为字符串，因为 chatStore 中的数字人 ID 是字符串类型
  const digitalHumanId = String(roleId)
  return chatStore.getUnreadCount(digitalHumanId) || 0
}

/**
 * 🔧 格式化未读消息数量显示（超过 99 显示 99+）
 */
const formatUnreadCount = (count: number): string => {
  if (count > 99) {
    return '99+'
  }
  return String(count)
}
const loading = ref(false)
const isAtTop = ref(true) // 🔧 跟踪虚拟列表是否在顶部
const tabs = ref([
  {
    name: "Chat",
    type: 2,
  },
  {
    name: "Like",
    type: 1,
  },
]);
/**
 * 删除消息
 */
const handleDelete = async (id: string) => {
  const confirmed = await dialog.confirm({
    title: t('message.delete'),
    message: t('message.deleteMessage'),
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#667eea'
  })
  if (confirmed) {
    showLoadingToast(t('message.deleting'))
    MessageAPI.deleteDialogue({ id, type: activeTab.value })
      .then(res => {
        console.log(res)
        showToast(t('message.deleteSuccess'), { type: 'success' })
        getMessageListFun()
      })
      .catch(err => {
        console.log(err)
        showToast(t('message.deleteFailed'), { type: 'error' })
      })
      .finally(() => {
        closeToast()
      })
  }
}
/**
 * 搜索
 */
const handleSearch = () => {
  localStorage.setItem('FromSearchRoute', window.location.pathname)
  router.push('/search')
}
/**
 * 切换标签
 */
const handleTabClick = async (type: number) => {
  // 切换标签时清空已动画项，让新标签的内容可以播放动画
  animatedItems.value.clear()
  // 🔧 重置顶部状态，允许下拉刷新
  isAtTop.value = true
  await messageStore.switchTab(type as 1 | 2)
  restoreScroll()
  nextTick(() => {
    setupIntersectionObserver()
  })
}
/**
 * 获取消息列表
 */
const getMessageListFun = async () => {
  showLoadingToast(t('login.loading'))
  await messageStore.refresh()
  closeToast()
}
/**
 * 格式化时间显示
 */
const formatTime = (timestamp: number): string => {
  // 如果时间戳是秒级的，需要 *1000
  const date = new Date(timestamp * 1000);
  const now = new Date();

  const diff = now.getTime() - date.getTime();

  if (diff < 60000) {
    return ("just now");
  }

  if (diff < 3600000) {
    const minutes = Math.floor(diff / 60000);
    return `${minutes} ${("minutes ago")}`;
  }

  if (diff < 86400000) {
    const hours = Math.floor(diff / 3600000);
    return `${hours} ${("hours ago")}`;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yesterday = new Date(today.getTime() - 86400000);

  if (date >= today) {
    return date.toLocaleTimeString("en", { hour: "2-digit", minute: "2-digit" });
  } else if (date >= yesterday) {
    return `${("yesterday")} ${date.toLocaleTimeString("en", { hour: "2-digit", minute: "2-digit" })}`;
  } else {
    return date.toLocaleDateString("en", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
};

/**
 * 刷新
 */
const onRefresh = async () => {
  try {
    loading.value = true
    await messageStore.refresh()
    // 🔧 刷新后重置到顶部
    isAtTop.value = true
    // 🔧 下拉刷新后，确保新数据能正确显示（修复透明度为0的问题）
    await nextTick()
    // 🔧 为所有消息项添加动画类，确保数据能显示
    Object.values(itemRefs.value).forEach((el) => {
      if (el) {
        const itemId = el.getAttribute('data-item-id')
        if (itemId) {
          // 🔧 如果元素还没有动画类，添加它
          if (!el.classList.contains('fade-in-up')) {
            // 🔧 先移除可能存在的类，然后重新添加以触发动画
            el.classList.remove('fade-in-up')
            requestAnimationFrame(() => {
              el.classList.add('fade-in-up')
            })
          }
          // 🔧 确保在 animatedItems 中记录
          if (!animatedItems.value.has(itemId)) {
            animatedItems.value.add(itemId)
          }
        }
      }
    })
    // 🔧 重新设置观察器，处理后续进入视口的元素
    setupIntersectionObserver()
  } finally {
    loading.value = false
  }
}

/**
 * 🔧 新增：重试加载
 */
const handleRetry = async () => {
  // 🔧 重试时先清空数据和错误状态，确保骨架屏能显示
  const state = messageStore.getCurrentState()
  state.items = [] // 🔧 清空数据，让骨架屏能显示
  state.error = null // 🔧 清除错误状态
  state.loading = false // 🔧 确保 loading 为 false，让 refresh 能执行

  // 🔧 清空动画记录和引用，让新数据可以重新触发动画
  animatedItems.value.clear()
  itemRefs.value = {}
  // 🔧 重置顶部状态
  isAtTop.value = true

  loading.value = true
  try {
    await messageStore.refresh()
    // 🔧 数据加载完成后，等待 DOM 更新，然后重新设置观察器
    await nextTick()
    // 🔧 立即为所有消息项添加动画类，确保数据能显示
    Object.values(itemRefs.value).forEach((el) => {
      if (el) {
        const itemId = el.getAttribute('data-item-id')
        if (itemId && !animatedItems.value.has(itemId)) {
          animatedItems.value.add(itemId)
          el.classList.add('fade-in-up')
        }
      }
    })
    // 🔧 重新设置观察器，处理后续进入视口的元素
    setupIntersectionObserver()
  } finally {
    loading.value = false
  }
}
/**
 * 处理消息点击
 */
const handleItemClick = (info: any) => {
  info.deleteId = info.id
  info.id = info.roleId

  const preData = {
    background: info.roleInfo.background,
    name: info.name,
    avatar: info.avatar,
    id: info.id,
  }

  // 跳转
  router.push({ path: '/chat', query: { preData: encodeURIComponent(JSON.stringify(preData)), route: route.path } }).catch(() => { })
}
/**
 * 挂载
 */
const containerRef = ref<HTMLElement>()
const messageListContainerRef = ref<HTMLElement>()
const virtualListHeight = ref('calc(100vh - 250px)') // 默认高度

// 🔧 动态计算虚拟列表高度
const updateVirtualListHeight = () => {
  if (messageListContainerRef.value) {
    const rect = messageListContainerRef.value.getBoundingClientRect()
    const windowHeight = window.innerHeight
    const availableHeight = windowHeight - rect.top - 100 // 100px for bottom safe area
    const finalHeight = Math.max(300, availableHeight)
    virtualListHeight.value = `${finalHeight}px`
  }
}

/**
 * 保存滚动位置
 */
const saveScroll = () => {
  if (!containerRef.value) return
  messageStore.saveScrollPosition(containerRef.value.scrollTop)
}
/**
 * 滚动
 */
const onContainerScroll = () => {
  saveScroll()
  // 滚动时收起已打开的 SwipeCell，避免多个同时打开
  closeOpenedSwipe()
}

/**
 * 🔧 处理虚拟列表滚动
 */
const handleVirtualListScroll = (event: Event) => {
  const target = event.target as HTMLElement
  // 检查是否在顶部（允许 5px 的误差）
  isAtTop.value = target.scrollTop <= 5

  // 加载更多：滚动到底部附近时触发
  const scrollBottom = target.scrollHeight - target.scrollTop - target.clientHeight
  if (scrollBottom < 100 && !loadingMore.value && hasMore.value) {
    messageStore.loadMore()
  }

  // 保存滚动位置
  saveScroll()
  // 滚动时收起已打开的 SwipeCell
  closeOpenedSwipe()
}
/**
 * 恢复滚动位置
 */
const restoreScroll = () => {
  nextTick(() => {
    if (!containerRef.value) return
    const maxScroll = Math.max(0, containerRef.value.scrollHeight - containerRef.value.clientHeight)
    const saved = messageStore.getScrollPosition()
    containerRef.value.scrollTop = Math.min(saved, maxScroll)
  })
}

// 仅允许单个 SwipeCell 打开
const swipeRefs = ref<Record<string, any>>({})
const openedSwipeId = ref<string | null>(null)
const setSwipeRef = (id: string, el: any) => {
  if (el) swipeRefs.value[id] = el
}
/**
 * 打开SwipeCell
 */
const handleSwipeOpen = (id: string) => {
  if (openedSwipeId.value && openedSwipeId.value !== id) {
    swipeRefs.value[openedSwipeId.value]?.close?.()
  }
  openedSwipeId.value = id
}
/**
 * 关闭SwipeCell
 */
const handleSwipeClose = (id: string) => {
  if (openedSwipeId.value === id) openedSwipeId.value = null
}
/**
 * 关闭所有打开的SwipeCell
 */
const closeOpenedSwipe = () => {
  if (openedSwipeId.value) {
    swipeRefs.value[openedSwipeId.value]?.close?.()
    openedSwipeId.value = null
  }
}

/**
 * 消息项动画相关
 */
const itemRefs = ref<Record<string, HTMLElement>>({})
const animatedItems = ref<Set<string>>(new Set())
const setItemRef = (id: string, el: any) => {
  if (el) {
    itemRefs.value[id] = el as HTMLElement

    // 🔧 虚拟列表优化：检查元素是否已有动画类
    // 虚拟列表会重新创建 DOM 元素，即使 ID 相同，新元素也需要添加动画类
    if (!el.classList.contains('fade-in-up')) {
      // 记录到 animatedItems（避免 Intersection Observer 重复处理）
      animatedItems.value.add(id)
      // 使用 requestAnimationFrame 确保 DOM 已渲染
      requestAnimationFrame(() => {
        el.classList.add('fade-in-up')
      })
    }
  }
}

/**
 * 使用 Intersection Observer 检测元素进入视口
 */
let observer: IntersectionObserver | null = null

/**
 * 设置Intersection Observer
 */
const setupIntersectionObserver = () => {
  if (observer) {
    observer.disconnect()
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const itemId = entry.target.getAttribute('data-item-id')
          // 🔧 虚拟列表优化：只处理尚未添加动画的元素
          // 避免重复添加动画类，与 setItemRef 配合使用
          if (itemId && !animatedItems.value.has(itemId)) {
            animatedItems.value.add(itemId)
            // 确保元素有动画类
            if (!entry.target.classList.contains('fade-in-up')) {
              requestAnimationFrame(() => {
                entry.target.classList.add('fade-in-up')
              })
            }
          }
        }
        // 移除离开视口时的处理，保持元素可见状态
        // 一旦元素播放过动画，就保持可见，不再移除 fade-in-up 类
      })
    },
    {
      root: containerRef.value,
      rootMargin: '0px',
      threshold: 0.1,
    }
  )

  // 观察所有消息项，并检查已在视口内的元素
  Object.values(itemRefs.value).forEach((el) => {
    if (el) {
      const itemId = el.getAttribute('data-item-id')
      // 检查元素是否已经在视口内
      const rect = el?.getBoundingClientRect()
      const containerRect = containerRef.value?.getBoundingClientRect()
      const isInViewport = rect?.top < (containerRect?.bottom || 0) && rect?.bottom > (containerRect?.top || 0)

      if (isInViewport && itemId && !animatedItems.value.has(itemId)) {
        animatedItems.value.add(itemId)
        el.classList.add('fade-in-up')
      }

      observer?.observe(el)
    }
  })
}

/**
 * 监听消息列表变化，重新设置观察器（确保数据变化时能正确显示）
 */
watch(
  () => messageList.value,
  () => {
    nextTick(() => {
      // 🔧 立即为所有消息项添加动画类，确保数据能显示
      Object.values(itemRefs.value).forEach((el) => {
        if (el) {
          const itemId = el.getAttribute('data-item-id')
          if (itemId) {
            // 🔧 如果元素还没有动画类，添加它
            if (!el.classList.contains('fade-in-up')) {
              // 🔧 先移除可能存在的类，然后重新添加以触发动画
              el.classList.remove('fade-in-up')
              requestAnimationFrame(() => {
                el.classList.add('fade-in-up')
              })
            }
            // 🔧 确保在 animatedItems 中记录
            if (!animatedItems.value.has(itemId)) {
              animatedItems.value.add(itemId)
            }
          }
        }
      })
      // 🔧 重新设置观察器，处理后续进入视口的元素
      setupIntersectionObserver()
    })
  },
  { deep: true }
)
/**
 * 删除所有 <thinking>...</thinking>（包括内部内容）
 */
const removeThinkingWithRegex = (str: string) => {
  return str
    .replace(/<thinking\b[^>]*>[\s\S]*?<\/thinking>/gi, '') // 移除 thinking 标签和内容
    .replace(/<\/?content\b[^>]*>/gi, '') // 只移除 content 标签，保留内容
    .replace(/<details\b[^>]*>[\s\S]*?<\/details>/gi, ''); // 移除 details 标签和内容
}
/**
 * 挂载
 */
onMounted(async () => {

  if (messageList.value.length === 0) {
    await messageStore.switchTab(activeTab.value as 1 | 2)
  }

  // showLoadingToast(t('login.loading'))
  setTimeout(async () => {
    if (messageList.value.length !== 0) {
      await messageStore.switchTab(activeTab.value as 1 | 2)
    }
    // 🔧 数据加载完成后，确保所有消息项能正确显示
    await nextTick()
    Object.values(itemRefs.value).forEach((el) => {
      if (el) {
        const itemId = el.getAttribute('data-item-id')
        if (itemId && !animatedItems.value.has(itemId)) {
          animatedItems.value.add(itemId)
          el.classList.add('fade-in-up')
        }
      }
    })
    setupIntersectionObserver()
  }, 1000)
  restoreScroll()
  nextTick(() => {
    setupIntersectionObserver()
    updateVirtualListHeight() // 🔧 计算虚拟列表高度
  })

  // 🔧 监听窗口大小变化
  window.addEventListener('resize', updateVirtualListHeight)

  closeToast()
})

/**
 * 卸载
 */
onUnmounted(() => {
  saveScroll()
  if (observer) {
    observer.disconnect()
    observer = null
  }
  // 🔧 移除窗口大小监听
  window.removeEventListener('resize', updateVirtualListHeight)
})
</script>

<style scoped lang="scss">
// 重写 AppPage 的样式，使其支持 flex 布局
.message-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-top: 42px;
  overflow-y: auto;
  // padding-bottom: 100px;
}

.header-content {
  flex-shrink: 0;
}

.search-box {
  display: flex;
  align-items: center;
  padding: 13px 10px;
  border-radius: 18px;
  background-color: v-bind('theme.colors.backgroundSecondary');

  .search-input {
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 14px;
    color: v-bind('theme.colors.textPrimary');
    font-size: 12px;
    line-height: 14px;
  }
}

.tabs-box {
  font-weight: 900;
  font-size: 16px;
  margin-right: 30px;
  display: flex;

  .tab-item {
    color: v-bind('theme.colors.textPrimary');
    margin-right: 30px;

    &.active {
      position: relative;
      color: #fff;

      &::after {
        content: '';
        display: block;
        background: #fff;
        width: 10px;
        height: 2px;
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.message-list-container {
  flex: 1;
  overflow-y: auto;
  margin-top: 15px;
  // padding-left: -20px;
  // padding-right: -20px;
}

.message-list {
  // 🔧 虚拟列表接管了高度和滚动，这里不再需要
  // height: 100vh;
  // overflow-y: auto;
  // padding: 0 20px;
  // padding-bottom: 250px;

  // 美化滚动条（移到虚拟列表容器）
  // &::-webkit-scrollbar {
  //   width: 4px;
  // }

  // &::-webkit-scrollbar-track {
  //   background: transparent;
  // }

  &::-webkit-scrollbar-thumb {
    background: v-bind('theme.colors.backgroundSecondary');
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: v-bind('theme.colors.backgroundQuinary');
  }
}

.message-item-wrapper {
  margin-bottom: 10px;
  opacity: 0;
  transform: translateY(20px);

  &:first-child {
    margin-top: 10px;
  }
}

.fade-in-up {
  animation: fadeInUp 0.5s ease-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.delete-btn {
  width: 40px;
  background: #D65050;
  height: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  flex-shrink: 0;

  img {
    width: 50%;
    // height: 50%;
    flex-shrink: 0;

  }
}

.message-content {
  color: v-bind('theme.colors.textPrimary');
}

.message-content-time {
  color: rgba(255, 255, 255, 0.3);
}

:deep(.van-pull-refresh__head) {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
}

.loading-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  opacity: 0.8;
  width: 100%;
  padding: 10px 0;

  .loading-spinner {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;

    .spinner-ring {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: linear-gradient(135deg, #C489FF 0%, #6868FF 100%);
      animation: spinner-bounce 1.4s ease-in-out infinite both;
      flex-shrink: 0;

      &:nth-child(1) {
        animation-delay: -0.32s;
      }

      &:nth-child(2) {
        animation-delay: -0.16s;
      }

      &:nth-child(3) {
        animation-delay: 0;
      }
    }
  }

  .loading-text {
    font-size: 12px;
    color: v-bind('theme.colors.textSecondary');
    font-weight: 400;
    letter-spacing: 0.5px;
  }
}

// 🔧 弹跳动画
@keyframes spinner-bounce {

  0%,
  80%,
  100% {
    transform: scale(0.8);
    opacity: 0.5;
  }

  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

// 🔧 重试按钮样式
.retry-btn {
  padding: 10px 24px;
  // background: linear-gradient(180deg, #5A68FF 0%, #95A5FF 100%);
  border-radius: 18px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.3s;

  &:active {
    opacity: 0.8;
  }
}

// 🔧 错误图标样式
.error-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;

  .error-icon-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(214, 80, 80, 0.2);
    border: 2px solid #D65050;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #D65050;
    font-size: 32px;
    font-weight: 900;
    line-height: 1;
  }
}

.retry-btn {
  font-family: Avenir, Avenir;
  font-weight: 500;
  font-size: 14px;
  color: #7284F7;
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
  border-radius: 20px;
  border: 1px solid #7284F7;
  width: 100px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 🔧 骨架屏样式
.message-list-skeleton {
  padding: 10px 0;

  .skeleton-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 10px;
    background-color: v-bind('theme.colors.backgroundSecondary');

    .skeleton-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: linear-gradient(90deg,
          rgba(255, 255, 255, 0.1) 0%,
          rgba(255, 255, 255, 0.2) 50%,
          rgba(255, 255, 255, 0.1) 100%);
      background-size: 200% 100%;
      animation: skeleton-loading 1.5s ease-in-out infinite;
      flex-shrink: 0;
    }

    .skeleton-content {
      flex: 1;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .skeleton-line {
        height: 12px;
        border-radius: 6px;
        background: linear-gradient(90deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.1) 100%);
        background-size: 200% 100%;
        animation: skeleton-loading 1.5s ease-in-out infinite;

        &.skeleton-line-title {
          width: 60%;
          height: 14px;
        }

        &.skeleton-line-text {
          width: 85%;
          height: 12px;
        }
      }
    }
  }
}

// 🔧 骨架屏加载动画
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

// 🔧 未读消息数量样式
.unread-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  // background: linear-gradient(180deg, #FF4D8D 0%, #FF6B9D 100%);
  background: #FF60CE;
  border-radius: 9px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;

  // 如果数字超过 99，显示 99+
  &::after {
    content: '';
  }
}

/* 加载更多样式 */
.load-more-loading {
  .loading-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.2);
    border-top: 2px solid rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>